import {UserOnboarding} from "@irati/types"
import OnboardingStep from "../enums/Step"

export default function hasSetDetails(onboarding?: UserOnboarding) {
  return onboarding?.completedSteps?.includes(OnboardingStep.SET_DETAILS)
}
